export const webhooksSubscriptionsToDeleteTasks = ({ subscriptions, currentAccountMapping, otherConnectedAccountsIds }) => {
  const { id: currentAccountMappingId } = currentAccountMapping;

  const result = {};
  const addResult = (key, { service, info = '', subscription }) => {
    while (result[key]) key = `dup_${key}`;
    if (key.startsWith('dup_')) info = `(Duplicate) ${info}`;
    result[key] = {
      key,
      deleteTask: {
        type: 'subscription',
        action: 'delete',
        service,
        subscription,
        info,
      }
    };
  };

  // eslint-disable-next-line no-unused-vars
  for (const w of subscriptions) {
    const {
      id: subscriptionId = '',
      filter: {
        id: serviceId = '',
      } = {},
      delivery_method: {
        url: deliveryUrl = ''
      } = {}
    } = w;
    const name = new URLSearchParams(deliveryUrl.split('?')[1] || '').get('dedupKey') || '';
    //TODO: Get Real Service Summary
    //JIRA: https://pagerduty.atlassian.net/browse/ITS-5018
    const service = { id: serviceId, summary: `ID = ${serviceId}` };
    const subscription = { id: subscriptionId };

    if (otherConnectedAccountsIds.some(id => name.startsWith(`JIRA_integration_${id}`))) {
      continue;
    }

    if (!name.startsWith(`JIRA_integration_${currentAccountMappingId}_`)) {
      addResult(`invalid_name_${name}`, {
        info: 'There is no Jira account using this webhook',
        service,
        subscription,
      });
      continue;
    }

    if (name !== `JIRA_integration_${currentAccountMappingId}_${serviceId}`) {
      addResult(`invalid_name_${name}`, {
        info: 'webhook name is corrupted, we can not properly track it',
        service,
        subscription,
      });
      continue;
    }

    addResult(name, { service, subscription });
  }

  return result;
};
